export default {
  getImportCsv: {
    url: '/bulk_import_csv_file/:id/',
    options: {
      method: 'GET',
    },
  },
  getImportPdf: {
    url: '/bulk_import_pdf_file/:id/',
    options: {
      method: 'GET',
    },
  },
}
